'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';
import { useHasCodeAccess } from '@/data/code-sessions/use-has-code-access';
import { focusNewSessionComposer } from '@/lib/code-sessions/code-composer-focus';
import { COMPOSER_HOTKEY_OPTIONS } from '@/lib/keyboard-shortcuts/composer-hotkey-options';
const NEW_SESSION_PATH = '/code';

/**
 * The one ⌘⇧O handler, on every page including /code: opens the /code
 * new-session UI and focuses its composer once that page shows.
 */
export function CodeNewSessionShortcut() {
  const $ = _c(8);
  const router = useRouter();
  const pathname = usePathname();
  const hasCodeAccess = useHasCodeAccess();
  const focusOnArrival = useRef(false);
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t0 = () => {
      if (!focusOnArrival.current) {
        return;
      }
      focusOnArrival.current = false;
      if (pathname === NEW_SESSION_PATH) {
        focusNewSessionComposer();
      }
    };
    t1 = [pathname];
    $[0] = pathname;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== pathname || $[4] !== router) {
    t2 = () => {
      router.push(NEW_SESSION_PATH);
      if (pathname === NEW_SESSION_PATH) {
        focusNewSessionComposer();
      } else {
        focusOnArrival.current = true;
      }
    };
    $[3] = pathname;
    $[4] = router;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== hasCodeAccess) {
    t3 = {
      ...COMPOSER_HOTKEY_OPTIONS,
      preventDefault: true,
      enabled: hasCodeAccess
    };
    $[6] = hasCodeAccess;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useHotkeys("mod+shift+o", t2, t3);
  return null;
}